import src from "IMAGE";
export default { src, width: 600, height: 61, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAHElEQVR42mOom366f8mlpplnWuecA6LeRRchJAC/uQ+a8yCbtQAAAABJRU5ErkJggg=="};
